import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Modal } from "react-bootstrap";

// img
import p1 from "../../../../Assets/images/p1.png";
import { useNavigate, useParams } from "react-router-dom";
import {
  ACCEPT_BOOKING,
  REJECT_BOOKING,
  VIEW_BOOKING,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import moment from "moment";
import MakeOfferPop from "../Modals/MakeOfferPop";
import ImagePreview from "../../../../components/Common/ImagePreview";
import noImg from "../../../../Assets/images/no-img.png";

const BookingDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showModalView, setShowModalView] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModalView(true);
  };

  const handleModalClose = () => {
    setShowModalView(false);
    setSelectedImage(null);
  };
  const [data, setData] = useState();
  const [Offer, setOffer] = useState();
  // const userHasMadeOffer = data?.userHasMadeOffer;

  const getData = async () => {
    try {
      const res = await VIEW_BOOKING(id);

      if (res?.data?.status === "success") {
        setData(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };
  const handleOffer = () => setOffer(!Offer);

  const acceptRejectHandler = async (type) => {
    try {
      let res;
      const body = { bookingId: id };
      if (type === "accept") {
        res = await ACCEPT_BOOKING(body);
      }
      if (type === "reject") {
        res = await REJECT_BOOKING(body);
      }
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/booking/booking-request");
      } else {
        toast.success(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) getData();
  }, [id]);

  return (
    <>
      <MakeOfferPop
        Offer={Offer}
        setOffer={setOffer}
        makeOfferHandler={() => acceptRejectHandler()}
      />
      <section className="bookingDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Pickup Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactName || "N/A"}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactNumber || "N/A"}
                        </p>
                      </div>
                    </Col>
                    {/* <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpType.size} 
                        </p>
                      </div>
                    </Col> */}
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Size:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpType?.weight ? `${data?.pickUp?.pickUpType?.weight}(lb)` : "N/A"}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking ID:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingNumber || "N/A"}
                        </p>
                      </div>
                    </Col>
                    {data?.bookingType !== "instant" &&
                      <Col md="4" sm="6" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Pickup Date
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.pickUp?.pickUpDate ? moment(data?.pickUp?.pickUpDate).format(
                              "MM/DD/YYYY"
                            ) : "N/A"}
                          </p>
                        </div>
                      </Col>}
                    {data?.bookingType !== "instant" &&
                      <Col md="4" sm="6" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Pickup Time:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {moment(data?.pickUp?.pickUpTime, "HH:mm:ss").format(
                              "hh:mm A"
                            ) || "N/A"}
                          </p>
                        </div>
                      </Col>}

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle Type
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.serviceType || "N/A"}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle
                        </label>
                        <p className="m-0 fw-bold themeClr">{data?.services || "N/A"}</p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Location:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.address || "N/A"}
                        </p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Mode:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingTypeRequest === "normal" ? "Standard" : "Bidding"}
                        </p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingType === "instant" ? "Instant" : "Scheduled"}
                        </p>
                      </div>
                    </Col>

                  </Row>
                  <div className="py-2">
                    <h6 className="m-0 fw-bold themeBLue">Additional Notes</h6>
                    <p className="m-0">{data?.pickUp?.additionalNotes}</p>
                  </div>
                </div>
              </div>
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Dropoff Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactName || "N/A"}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactNumber || "N/A"}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Location
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.address || "N/A"}
                        </p>
                      </div>
                    </Col>
                    {data?.bookingType !== "instant" &&
                      <Col md="4" sm="6" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Drop off Date
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.dropOff?.dropOffDate ? moment(data?.dropOff?.dropOffDate).format(
                              "MM/DD/YYYY"
                            ) : "N/A"}
                          </p>
                        </div>
                      </Col>}

                    {data?.bookingType !== "instant" &&
                      <Col md="4" sm="6" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Drop off Time
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.dropOff?.dropOffTime && moment(data.dropOff.dropOffTime, "HH:mm:ss").isValid()
                              ? moment(data.dropOff.dropOffTime, "HH:mm:ss").format("hh:mm A")
                              : "N/A"}
                          </p>
                        </div>
                      </Col>}
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          {data?.bookingTypeRequest === "normal" ? "Total Amount" : "Bid Amount"}
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {`$${data?.totalOffer}` || "N/A"} </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Offer Amount
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {`$${data?.bidAmount}` || "N/A"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

            </Col>

            <Col lg="12" className="my-2">
              {data?.serviceType === "Towing" ? (
                <div className="py-2">
                  <div className="cardCstm p-3 rounded bg-white">
                    <div className="head m-0 mb-2">
                      <h4 className="m-0 fw-bold themeBlue">Vehicle Details</h4>
                    </div>
                    <Row className="border-bottom">
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle license plate number:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.licensePlateNumber || "N/A"}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle make:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.make || "N/A"}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle model:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.model || "N/A"}
                          </p>
                        </div>
                      </Col>
                      <Col md="4" className="">
                        <div className="inner h-100 border-bottom pb-2">
                          <label
                            htmlFor=""
                            className="m-0 form-label themeBlue m-0"
                          >
                            Vehicle color:
                          </label>
                          <p className="m-0 fw-bold themeClr">
                            {data?.towingVehicleDetails?.color || "N/A"}
                          </p>
                        </div>
                      </Col>
                      {/* <Col md="12" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Vehicle condition:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.towingVehicleDetails?.condition}
                        </p>
                      </div>
                    </Col> */}
                    </Row>
                    <div className="py-2">
                      <h6 className="m-0 fw-bold themeBLue">Vehicle images:</h6>
                      <Row>
                        {/* <Col sm="6" className="my-2">
                        <img
                          src={p1}
                          alt=""
                          className="img-fluid w-100 rounded"
                        />
                      </Col> */}
                        <Col sm="6" className="my-2">
                          <img
                            src={data?.towingVehicleDetails?.image || noImg}
                            alt=""
                            className="img-fluid w-50 h-50 rounded"
                            onClick={() =>
                              handleImageClick(
                                data?.towingVehicleDetails?.image || p1
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <ImagePreview
                            showModal={showModalView}
                            selectedImage={selectedImage}
                            onClose={handleModalClose}
                          // title="Vehicle Image Preview"
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="py-2">
                  <div className="cardCstm p-3 rounded bg-white">
                    <div className="py-2">
                      <h6
                        className="m-0 fw-bold themeBLue"
                        style={{ paddingLeft: "15px" }}
                      >
                        Vehicle images:
                      </h6>
                      <Row>
                        <Col sm="6" className="my-2">
                          <div
                            style={{
                              // display: "flex",
                              // flexWrap: "wrap",
                              // gap: "10px",

                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              flexWrap: "nowrap",
                              gap: "40px",
                              width: "max-content",
                              paddingLeft: "15px",
                            }}
                          >
                            {data?.image?.map((image, index) => (
                              <img
                                src={image || noImg}
                                alt={`image-${index}`}
                                key={index}
                                className="img-fluid"
                                style={{
                                  marginBottom: "10px",
                                  height: 100,
                                  width: 100,
                                }}
                              />
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              )}
            </Col>

            <Row>

              {!!data?.status &&
                data?.status !== "confirmed" &&
                !data?.bidAmount && (
                  <>

                    {
                      data?.bookingTypeRequest !== "normal" ?
                        <Col lg="4" className="col-6 my2">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn w-100"
                            type="button"
                            onClick={handleOffer}
                          // disabled={!!data?.bidAmount}
                          >
                            Make Offer
                          </Button>
                        </Col>

                        :
                        (data?.status !== "confirmed" && !data?.driverDetails?._id) && (
                          <Col lg="4" className="col-6">
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn w-100 "
                              type="button"
                              onClick={(e) => acceptRejectHandler("accept")}
                            >
                              Accept
                            </Button>
                          </Col>
                        )
                    }

                    {(data?.status !== "confirmed" && !data?.driverDetails?._id) && (
                      <Col lg="4" className="col-6">
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                          type="button"
                          onClick={(e) => acceptRejectHandler("reject")}
                        >
                          Reject
                        </Button>
                      </Col>
                    )}
                  </>)}
            </Row>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BookingDetail;
